import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
import heroImg   from '../images/bradenton_florida_1600.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image41.webp';
import slideImg2 from '../images/image95.webp';
import slideImg3 from '../images/image42.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const ellentonConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Ellenton Tree Service | Sam\'s Tree Service',
  metaDescription: 'Expert tree trimming and removal in Ellenton, FL. Sam\'s Tree Service handles dangerous trees safely and professionally.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_ellenton',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Ellenton',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Ellenton Specializing In Dangerous Trees',

  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we serve homeowners and businesses across 
     <strong>Ellenton</strong> with dependable, professional tree care. The mix of 
     established residential neighborhoods and open lots in this area means trees grow 
     large and fast and when Florida's storm season arrives, overgrown or weakened trees 
     become a real liability. Our team takes on the difficult jobs with the right equipment 
     and a safety first approach.`,

    `We specialize in <strong>dangerous tree removal and trimming</strong> including 
     large limbs threatening rooftops and fences, storm compromised trunks, trees with 
     root damage leaning toward structures, and heavy canopy growth that creates wind load 
     risk. We handle the entire job cleanly from start to finish.`,

    `<strong>Sam's Tree Service</strong> provides reliable, affordable tree care throughout 
     <strong>Ellenton</strong> and the broader <strong>Manatee County</strong> area
     protecting your property and keeping your landscape healthy through every season.`,
  ],

  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Ellenton, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_Ellenton = () => <LocationPage config={ellentonConfig} />;
export default Services_Ellenton;
